import {
    Box,
    Button, CircularProgress,
    Divider,
    IconButton,
    List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
    Paper,
    Tooltip,
    Typography,
} from "@material-ui/core";

import DeleteIcon from "@material-ui/icons/Delete";

export function QuestionBankSidebar({
    selectedQuestions,
    selectedCount,
    onOpenDetails,
    onRemove,
    onClear,
    onSubmit,
    loading,
}) {
    return (
        <Paper style={{ padding: 16, position: "sticky", top: 16 }}>
            <Typography variant="h6">Banco da Avaliação</Typography>

            <Box mt={1} mb={1}>
                <Typography variant="body2" color="textSecondary">
                    {selectedCount === 0
                        ? "Nenhuma questão selecionada ainda."
                        : `Você selecionou ${selectedCount} questão(ões).`}
                </Typography>
            </Box>

            <Divider />

            <Box mt={1} style={{ maxHeight: 420, overflow: "auto" }}>
                <List dense>
                    {selectedQuestions.map((q) => (
                        <ListItem key={q.id} button onClick={() => onOpenDetails(q)}>
                            <ListItemText
                                primary={q.code}
                                secondary={q.question?.substring(0, 100)}
                            />
                            <ListItemSecondaryAction>
                                <Tooltip title="Remover">
                                    <IconButton edge="end" onClick={() => onRemove(q.id)}>
                                        <DeleteIcon />
                                    </IconButton>
                                </Tooltip>
                            </ListItemSecondaryAction>
                        </ListItem>
                    ))}
                </List>
            </Box>

            <Divider style={{ marginTop: 8, marginBottom: 12 }} />

            <Box display="flex" justifyContent="space-between">
                <Button onClick={onClear} disabled={selectedCount === 0}>
                    Limpar
                </Button>

                <Button
                    color="primary"
                    variant="contained"
                    onClick={onSubmit}
                    disabled={selectedCount === 0 || loading}
                    startIcon={loading ? <CircularProgress size={12} /> : undefined}
                >
                    Confirmar
                </Button>
            </Box>
        </Paper>
    );
}
